import type { ProposalBatch } from "@stockline/shared/types/ai/proposal"

/**
 * Pure filter used by `useProposalBatchesByConversation`'s email-junction
 * fallback. Returns the subset of `batches` that touch any of the supplied
 * `preOrderIds` via a `proposals[]` entry with `entityType === "pre_order"`.
 *
 * Matching is intentionally narrow: only batch-level pre-order proposals
 * count. Per-flow proposals (`entityType === "pre_order_flow"`) carry a flow
 * id, not a pre-order id, so we'd need a second hop through the flow table
 * to relate them — out of scope for this lookup. The badge fix targets the
 * "AI created a pre-order from an email" case, which always has a
 * batch-level `pre_order` proposal.
 */
export function filterBatchesByPreOrderIds(
  batches: ProposalBatch[],
  preOrderIds: ReadonlySet<string>
): ProposalBatch[] {
  if (preOrderIds.size === 0) return []
  return batches.filter((batch) =>
    batch.proposals?.some(
      (p) =>
        p.entityType === "pre_order" &&
        p.entityId != null &&
        preOrderIds.has(p.entityId)
    )
  )
}
